import { env } from "@config/environment";
import { OpenPanel } from "@openpanel/web";

let op: OpenPanel | null = null;

export function initializeOpenPanel(): void {
  // Guard against re-initialization (e.g. React StrictMode double-invoking
  // effects in development).
  if (op) return;

  try {
    op = new OpenPanel({
      clientId: env.OPENPANEL_CLIENT_ID,
      apiUrl: env.OPENPANEL_API_URL,
      trackScreenViews: false,
      trackAttributes: false,
      sessionReplay: {
        enabled: true,
        sampleRate: 0.05, // Session Replay enabled, recording 5% of all sessions
        maskAllInputs: true, // inputs are masked
        maskAllText: false, // text content is not masked
        blockSelector: "", // do not block any element from recording
      },
    });

    op.setGlobalProperties({ "damenkom-version": "2" });
  } catch {
    op = null;
  }
}

export function trackEvent(
  eventName: string,
  options?: Record<string, unknown>,
): void {
  if (!op) return;

  op.track(eventName, options);
}

export function trackAction(
  action: string,
  orderId: string,
  redirectionUrl?: string,
): void {
  const properties: Record<string, unknown> = {
    Action: action,
    "Order ID": orderId,
    "Device Language": Intl.DateTimeFormat().resolvedOptions().locale,
    ...(redirectionUrl && { redirectionUrl }),
  };

  trackEvent("Button Click", properties);
}

export function trackPage(
  pageName: string,
  properties: {
    orderId: string;
    redirectionUrl?: string;
    [key: string]: any;
  },
) {
  const finalProps: Record<string, unknown> = {
    "Page Name": pageName,
    "Order ID": properties.orderId,
    "Device Language": Intl.DateTimeFormat().resolvedOptions().locale,
    ...(properties.redirectionUrl && {
      redirectionUrl: properties.redirectionUrl,
    }),
    ...properties,
  };

  trackEvent("Page Load", finalProps);
}
